import { createContext } from 'preact';

const StorageContext: any = createContext({
    auth: null,
    memberID: null,
    branding: null,
    headerFooter: null,
    memberData: null,
    theme: null,
    queryParams: null,
    domainOwnerID: null,
    XTheme: null
});

export default StorageContext;
